export default {
  namespaced: true,

  state: {
    searchData: {},
    searchMessage: ""
  },
  getters: {
    searchAll(state) {
      return state.searchData.all || {};
    },
    searchFaq(state) {
      return state.searchData.faq || {};
    },
    searchNotice(state) {
      return state.searchData.notice || {};
    },
    searchProduct(state) {
      return state.searchData.product || {};
    },
    searchTechnical(state) {
      return state.searchData.technical || {};
    },
    searchApi(state) {
      return state.searchData.api || {};
    }
  },
  actions: {
    async getSearchData( //获取搜索结果
      { dispatch, commit, getters, rootGetters, state, rootState },
      data = {}
    ) {
      let res = await rootState.axios.post(
        "/server/portal/menu/queryDoclist",
        data
      );
      commit("setSearchData", res.data.data);
    }
  },

  mutations: {
    setSearchData(state, data) {
      state.searchData = data;
    },
    setSearchMessage(state, data) {
      state.searchMessage = data;
    }
  }
};
